<!-- src/app/components/create-token-modal/create-token-modal.component.html -->
<div class="modal-header">
  <h4 class="modal-title">Create New Token</h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="form-group">
      <label for="tokenName">ParnerId</label>
      <input type="text" class="form-control" id="partnerId" [(ngModel)]="partnerId" name="partnerId" />
    </div>
    <div class="form-group">
      <label for="tokenName">Name</label>
      <input type="text" class="form-control" id="tokenName" [(ngModel)]="token.Name" name="name" />
    </div>
    <div class="form-group">
      <label for="tokenExpiry">Expiry</label>
<!--      <input type="datetime-local" class="form-control" id="tokenExpiry" [(ngModel)]="token.Expiry" name="expiry" />-->
      <p-calendar  id="tokenExpiry"
                  [hideOnDateTimeSelect]="true"
                  [hourFormat]="'24'" [showOtherMonths]="false" [showTime]="true"
                  [showSeconds]="false"
                  [stepHour]="1"
                   (onSelect)="onDateSelect($event)"
                  [stepMinute]="15"></p-calendar>
    </div>
  </form>
</div>
<div class="content">
  <button type="button" class="iso-round-button iso-secondary mr-2" (click)="save()">Save</button>
  <button type="button" class="iso-round-button mr-2" (click)="cancel()">Cancel</button>

</div>
